var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.91 40H5.09C2.28 39.998.003 37.676 0 34.811V5.19C.002 2.324 2.28.002 5.09 0h49.82c2.81.002 5.088 2.324 5.09 5.189V34.81c-.002 2.865-2.28 5.187-5.09 5.189zM5.09 1.912c-1.774.002-3.213 1.469-3.215 3.277v29.623c.002 1.808 1.441 3.275 3.216 3.277h49.818c1.775-.002 3.214-1.469 3.216-3.277V5.189c-.002-1.808-1.441-3.275-3.216-3.277H5.091z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.713 10.04H28.287c-.435 0-.787-.457-.787-1.02 0-.564.352-1.02.787-1.02h13.426c.435 0 .787.456.787 1.02 0 .563-.352 1.02-.787 1.02zM51.053 10.04h-5.037A1.017 1.017 0 0 1 45 9.02c0-.564.455-1.02 1.016-1.02h5.037c.561 0 1.016.456 1.016 1.02 0 .563-.455 1.02-1.016 1.02z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.803 15.333h-7.287a1.008 1.008 0 0 1-1.016-1c0-.552.454-1 1.015-1h7.288c.036 0 .071.002.106.006.035-.004.07-.006.107-.006H48.303c.561 0 1.016.448 1.016 1 0 .553-.455 1-1.016 1H36.016c-.036 0-.072-.001-.107-.005a1.04 1.04 0 0 1-.106.005zM36.016 21.333H51.683c.451 0 .817-.447.817-1 0-.552-.366-1-.817-1H36.016c-.036 0-.072.002-.107.006a1.038 1.038 0 0 0-.106-.006h-7.287c-.562 0-1.016.448-1.016 1 0 .553.454 1 1.015 1h7.288c.036 0 .071-.002.106-.005.035.003.07.005.107.005zM28.515 27.333h7.288c.036 0 .071-.002.106-.005.035.003.07.005.107.005h17.287c.561 0 1.016-.447 1.016-1 0-.552-.455-1-1.016-1H36.016c-.036 0-.072.002-.107.006a1.04 1.04 0 0 0-.106-.006h-7.287c-.562 0-1.016.448-1.016 1 0 .553.454 1 1.015 1z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.44 34.04h-7.287a1.017 1.017 0 0 1-1.015-1.02c0-.564.454-1.02 1.015-1.02h7.288c.56 0 1.015.456 1.015 1.02 0 .563-.454 1.02-1.015 1.02zM27.622 34.04h-7.288a1.017 1.017 0 0 1-1.015-1.02c0-.564.454-1.02 1.015-1.02h7.288c.56 0 1.015.456 1.015 1.02 0 .563-.454 1.02-1.015 1.02zM15.803 34.04H8.516A1.017 1.017 0 0 1 7.5 33.02c0-.564.454-1.02 1.016-1.02h7.287c.56 0 1.015.456 1.015 1.02 0 .563-.454 1.02-1.015 1.02zM51.264 34.04h-7.292a1.017 1.017 0 0 1-1.016-1.02c0-.564.455-1.02 1.016-1.02h7.287c.561 0 1.016.456 1.016 1.02 0 .563-.455 1.02-1.016 1.02h.005z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.724 7.714 7.146 13.17l-.454-.714L15.27 7l.454.714z",
    fill: "#0D244D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.761 13.404 14.79 7.725l.452-.715 8.973 5.679-.453.715zM15.756 10.01l-6.89 4.328-.45-.716 6.89-4.33.45.717z",
    fill: "#0D244D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.796 15.698-8.973-5.679.452-.715 8.973 5.68-.453.714zM15.758 12.226l-5.17 3.278-.453-.714 5.17-3.279.453.715z",
    fill: "#0D244D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.796 17.916-8.973-5.68.452-.714 8.973 5.679-.453.715zM15.763 14.44l-3.273 2.14-.463-.707 3.273-2.141.463.708z",
    fill: "#0D244D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.796 20.133-8.973-5.679.452-.715 8.973 5.68-.453.714zM14.617 26.281l8.636-5.365.446.719L15.064 27l-.447-.719z",
    fill: "#0D244D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.641 20.506 8.912 5.774-.46.71-8.912-5.773.46-.71zM14.61 23.986l6.936-4.256.442.721-6.936 4.256-.443-.721z",
    fill: "#0D244D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.631 18.212 8.912 5.773-.46.71-8.912-5.773.46-.71zM14.632 21.77l5.203-3.224.446.719-5.204 3.224-.445-.72z",
    fill: "#0D244D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.655 15.995 8.912 5.773-.46.71-8.912-5.773.46-.71zM14.65 19.555l3.295-2.106.456.713-3.296 2.106-.455-.713z",
    fill: "#0D244D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.678 13.777 8.912 5.774-.46.71-8.912-5.773.46-.71zM6.563 12.585a.423.423 0 0 1 .584-.128l5.34 3.413a.423.423 0 0 1-.456.713L6.69 13.17a.423.423 0 0 1-.128-.585zM17.828 17.57a.423.423 0 0 1 .586-.121l5.28 3.472a.423.423 0 0 1-.464.707l-5.281-3.472a.423.423 0 0 1-.121-.586z",
    fill: "#0D244D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.454 13.703a.423.423 0 0 1 .421.425l-.029 6.74A.423.423 0 0 1 6 20.864l.03-6.74a.423.423 0 0 1 .424-.421zM23.991 12.623a.423.423 0 0 1 .42.427l-.059 6.682a.423.423 0 1 1-.846-.008l.059-6.681a.423.423 0 0 1 .426-.42zM14.975 18.065V15.95h.526v2.115h-.526z",
    fill: "#0D244D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.254 17.228h-2.012v-.525h2.012v.525z",
    fill: "#0D244D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardIcon);
export default __webpack_public_path__ + "static/media/ID_card_icon.cc0de223c9a82393af0e72b2747b3982.svg";
export { ForwardRef as ReactComponent };